import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PeerOwnershipInstitutionsTopInvestmentCentersViewModel } from './peer-ownership-institutions-breakdown.model';

export class PeerOwnershipInstitutionsTopInvestmentCentersConfiguration extends ReportSectionConfigurationBase {
  typeName = 'PeerOwnershipInstitutionsTopInvestmentCentersConfiguration';
  nodataLocalizationKeyName = 'peerOwnershipInstitutionsTopInvestmentCenters';
  readonly reportSection = ReportSection.PeerOwnershipInstitutionsTopInvestmentCenters;
  readonly name = 'peerOwnershipInstitutionsTopInvestmentCenters';
  readonly displayName = 'Top Investment Centers - Institutions';
  readonly applicableReportTypes = [ReportType.PeerOwnershipReport];
  readonly reportViewModelSections = [ReportViewModelSection.PeerOwnershipReport_InstitutionsTopInvestmentCenters];
  minSize = 2;
  maxSize = 4;
  defaultSize = 2;
  readonly availableDataSections = [];
}

export interface PeerOwnershipInstitutionsTopInvestmentCentersDataBag {
  [ReportViewModelSection.PeerOwnershipReport_InstitutionsTopInvestmentCenters]: PeerOwnershipInstitutionsTopInvestmentCentersViewModel;
}
